<template>
    <div class="modal modal-todo modal-contacted fade" tabindex="-1" role="dialog" ref="modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Contacted</h5>
                    <button type="button" class="close" @click="closeModal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="saveContactedVia">
                        <div class="form-group">
                            <label class="font-weight-bold mb-2">Via<span class="text-danger">*</span></label>
                            <div class="mb-2">
                                <div class="form-check form-check-inline mr-3" v-for="option in viaOptions" :key="option.value">
                                    <label class="form-check-label" style="cursor:pointer;">
                                        <input class="form-check-input" type="checkbox" :id="'via-' + option.value" :value="option.value" v-model="selectedVia">
                                        {{ option.label }}
                                    </label>
                                </div>
                            </div>
                            <div v-if="showViaError" class="text-danger small mt-1">Please select at least one option.</div>
                        </div>
                        <div v-if="showPaymentOptions" class="form-group">
                            <label class="font-weight-bold mb-2">Payment<span class="text-danger">*</span></label>
                            <div>
                                <div class="form-check form-check-inline mr-4" v-for="option in paymentOptions" :key="option.value">
                                    <label class="form-check-label" style="cursor:pointer;">
                                        <input class="form-check-input" type="radio" name="paymentOption" :value="option.value" v-model="selectedPaymentOption">
                                        {{ option.label }}
                                    </label>
                                </div>
                            </div>
                            <div v-if="showPaymentOptionError" class="text-danger small mt-1">Please select a payment option.</div>
                        </div>
                        <div class="form-group">
                            <label for="contacted-notes" class="font-weight-bold">Notes</label>
                            <textarea id="contacted-notes" class="form-control" v-model="contactedNotes" rows="4" placeholder="Type here..."></textarea>
                        </div>
                        <button type="submit" class="btn btn-submit btn-block mt-3 btn-primary" :disabled="isSaving || selectedVia.length === 0 || (showPaymentOptions && !selectedPaymentOption)">
                            Save
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContactedModal',
    data() {
        return {
            viaOptions: [
                { label: 'Video Call', value: 'video_call' },
                { label: 'Voice Call', value: 'voice_call' },
                { label: 'WhatsApp', value: 'whatsapp' },
                { label: 'Email', value: 'email' }
            ],
            paymentOptions: [
                { label: 'Pay to School', value: 'pay_to_school' },
                { label: 'Pay to Agency', value: 'pay_to_agency' },
                { label: 'No Pay', value: 'no_pay' }
            ],
            selectedVia: [],
            selectedPaymentOption: '',
            contactedNotes: '',
            isSaving: false,
            showViaError: false,
            showPaymentOptions: false,
            showPaymentOptionError: false
        }
    },
    mounted() {
        document.body.appendChild(this.$el);
    },
    methods: {
        openModal(unpaid_payment) {
            this.selectedVia = [];
            this.contactedNotes = '';
            this.showViaError = false;
            this.selectedPaymentOption = '';
            this.showPaymentOptions = unpaid_payment;
            this.showPaymentOptionError = false;
            
            this.$nextTick(() => {
                $(this.$refs.modal).modal({
                    backdrop: 'static',
                    keyboard: false
                });
            });
        },
        closeModal() {
            this.isSaving = false;
            $(this.$refs.modal).modal('hide');
        },
        saveContactedVia() {
            if (this.selectedVia.length === 0) {
                this.showViaError = true;
                return;
            }
            
            this.showViaError = false;

            if (this.showPaymentOptions && !this.selectedPaymentOption) {
                this.showPaymentOptionError = true;
                return;
            }
            
            this.showPaymentOptionError = false;
            this.isSaving = true;

            const payload = {
                via: this.selectedVia,
                notes: this.contactedNotes,
                payment_status: this.showPaymentOptions ? this.selectedPaymentOption : null
            };

            this.$emit('save', { payload });
            this.closeModal();
        }
    }
}
</script>
